export const tableHeader = (t) => [
    {
        id: 'version',
        type: 'text',
        value: t('policy:versions.table.version'),
    },
    {
        id: 'publishedDate',
        type: 'datetime',
        value: t('policy:versions.table.published'),
    },
    {
        id: 'reviewedDate',
        type: 'datetime',
        value: t('policy:versions.table.reviewed'),
    },
    {
        id: 'approvedDate',
        type: 'datetime',
        value: t('policy:versions.table.approved'),
    },
    {
        id: 'action',
        type: 'actions-policy-version',
        value: '',
    },
]
